import Warehouse from '../../../images/SVG/Finder/Warehouse.svg?raw'
import Park from '../../../images/SVG/Finder/Park.svg?raw'

export function useStep1(state) {

    const index = 1
    const title = "Let's start with your project's type and location."
    const questions = []

    questions.push({
        question: "Is this a Private or Public project?",
        name: "type",
        model: null,
        options: [
            {
                icon: Warehouse,
                value: "Private",
            },
            {
                icon: Park,
                value: "Public",
            }
        ]
    })

    questions.push({
        question: "Where is the project located?",
        model: null,
        name: "location",
        options: [
            {
                value: "Auckland",
            },
            {
                value: "Christchurch",
            },
            {
                value: "Waikato",
            },
            {
                value: "Wellington",
            },
            {
                value: "Canterbury",
                info: "Other than Christchurch"
            },
            {
                value: "Other",
                info: "Northland Bay of Plenty, Hawke's Bay, Tasman, Otago, Southland, Malborough"
            },
        ]
    })

    // Loop through state and set checked values
    for (const [key, value] of Object.entries(state)) {

        const q = questions.find(q => q.name === key)

        // Only change options in this step
        if (q !== undefined) {

            q.options.forEach(o => {
                delete o.checked
            })

            if (value !== "") {
                const o = q.options.find(o => o.value === value)
                o.checked = true
            }
        }
    }

    return {
        index,
        title,
        questions
    }
}

